<template>
    <v-autocomplete
        v-model="program"
        :items="programs"
        :label="props.label || $t('program')"
        item-value="id"
        item-title="name"
        clearable
        data-cy="program"
    />
</template>

<script setup lang="ts">
    const props = defineProps<{
        label?: string
    }>()
    const program = defineModel<number>()
    const {programs} = usePrograms()
</script>
